import { isStarted } from '../../threads/operators/isStarted';
import { connect } from 'react-redux';

// @ts-ignore untyped file
import { getGdprConsentToProcessEnabledForChatflow } from '../../gdpr/selectors/getGdprConsentToProcessEnabledForChatflow';
import { shouldRequireExplicitCookieConsent } from '../../selectors/widgetDataSelectors/shouldRequireExplicitCookieConsent';
import { getShowGdprConsentToProcess } from '../../gdpr/selectors/getShowGdprConsentToProcess';
// @ts-ignore untyped file
import { getSelectedThread } from '../../selected-thread/selectors/getSelectedThread';
import { getShowingHsBranding } from '../../selectors/widgetDataSelectors/getShowingHsBranding';
import UnifiedThreadView from '../components/UnifiedThreadView';
import { shouldShowMeetingsLink } from '../../meetings-links/selectors/shouldShowMeetingsLink';
import { toggleOnAndOffInputFocus } from '../../actions/inputEventActions';
import { selectAttachmentFile } from '../../file-uploads/actions/selectAttachmentFile';
import { getUserHasGivenConsentToProcess } from '../../gdpr/selectors/getHasUserGivenConsentToProcess';
import { getHasChannelSwitchedToEmail } from '../../threads/operators/threadGetters';
import { getShouldHideMessageEditor, getShouldHideForConsent } from '../selectors/getShouldHideMessageEditor';
import { getDisclaimerText } from '../../message-editor/selectors/getDisclaimerText';
export const mapStateToProps = state => {
  const showingGdprProcess = getGdprConsentToProcessEnabledForChatflow(state) && !getUserHasGivenConsentToProcess(state);
  const renderCookieConsentPrompt = shouldRequireExplicitCookieConsent(state);
  const requiresExplicitConsentToProcess = getShowGdprConsentToProcess(state);
  return {
    shouldShowMeetingsLink: shouldShowMeetingsLink(state),
    isThreadStarted: isStarted(getSelectedThread(state)),
    requiresExplicitConsentToProcess,
    showingGdprProcess,
    renderCookieConsentPrompt,
    disclaimerText: getDisclaimerText(state),
    showingHsBranding: getShowingHsBranding(state),
    isThreadTransferred: getHasChannelSwitchedToEmail(getSelectedThread(state)),
    shouldHideMessageEditor: getShouldHideMessageEditor(state),
    shouldHideAlerts: getShouldHideForConsent(state)
  };
};
const mapDispatchToProps = {
  toggleOnAndOffInputFocus,
  selectAttachmentFile
};
export default connect(mapStateToProps, mapDispatchToProps)(UnifiedThreadView);